module.exports = __webpack_public_path__ + "img/DE00436.ecaf1e1a.png";